import { miraSiHayCirilicos, isEmpty } from "./strings";
import i18n from "@/i18n";
import { useSelectedListsStore } from "@/stores/selectedLists";
const t = (key, params = {}) => i18n.global.t(key, params);

//----------------------------------------------------------------------------------------------------------------------------------------
// START validarCondicionesIniciales
//----------------------------------------------------------------------------------------------------------------------------------------
const validarCondicionesIniciales = async (
  profile,
  pedido,
  areaCliente,
  review,
  caracteristicasLente,
  _token /* reservado para futuras validaciones con API */,
  sending = false,
) => {
  //----------------------------------------------------------------------------------------------------------------------------------------
  // START Copiar valores bindeados a OJO Derecho a su correspondiente campo de OJO Izquierdo
  //----------------------------------------------------------------------------------------------------------------------------------------
  const ojoInDerecho = {
    ...pedido.listOJOIN.clsZES_OJO_INPUT.filter((ojo) => ojo.ZOJO === "D")[0],
  };
  const ojoInIzquierdo = {
    ...pedido.listOJOIN.clsZES_OJO_INPUT.filter((ojo) => ojo.ZOJO === "I")[0],
  };

  ojoInIzquierdo.TIPO_ISOTIPO = ojoInDerecho.TIPO_ISOTIPO;
  ojoInIzquierdo.CLASE_PROG = ojoInDerecho.CLASE_PROG;
  ojoInIzquierdo.TIPO_PROG = ojoInDerecho.TIPO_PROG;
  ojoInIzquierdo.VISUAL_PREF = ojoInDerecho.VISUAL_PREF;
  //----------------------------------------------------------------------------------------------------------------------------------------
  // END Copiar valores bindeados a OJO Derecho a su correspondiente campo de OJO Izquierdo
  //----------------------------------------------------------------------------------------------------------------------------------------

  // Activamos el Modificar Espesor si chkFreemax está activado
  if (ojoInDerecho.OPT_FRMX === "X") {
    ojoInIzquierdo.OPT_FRMX = "X";

    const originalOI = pedido.listOJOIN.clsZES_OJO_INPUT.find((ojo) => ojo.ZOJO === "I");
    if (originalOI) originalOI.OPT_FRMX = "X";

    if (pedido.listCABIN?.clsZES_CAB_INPUT?.[0]) {
      pedido.listCABIN.clsZES_CAB_INPUT[0].MOD_ESPESORES = "X";
    }
  }

  // Activar MOD_ESPESORES = 'X' en CABIN cuando hay precalibrado (F, C legacy o B esp. borde)
  const precalibrado = ojoInDerecho.PRECALIBRADO || "";
  if ((precalibrado === "F" || precalibrado === "B") && pedido.listCABIN?.clsZES_CAB_INPUT?.[0]) {
    pedido.listCABIN.clsZES_CAB_INPUT[0].MOD_ESPESORES = "X";
  }

  //----------------------------------------------------------------------------------------------------------------------------------------
  // START Validaciones para todos los pedidos (Normales o Enviados a Revisión)
  //----------------------------------------------------------------------------------------------------------------------------------------

  // Cambiar AUGRU de "INET" a "ONES" si está en "INET"
  // Asegurar AUGRU "INET" y FLAG_ONES "X"
  if (pedido.listCABIN?.clsZES_CAB_INPUT?.[0]) {
    pedido.listCABIN.clsZES_CAB_INPUT[0].AUGRU = "INET";
    pedido.listCABIN.clsZES_CAB_INPUT[0].FLAG_ONES = "X";
  }

  //JH.2024-05-22: VALIDAR: Si pide BigExact y no lleva lectura DNEye Scanner
  // No llamar a CargarDatosBIGEXACT aquí (calcular/enviar no deben “recargar” lectura desde SAP).
  // El dispositivo de la lectura aplicada se guarda en pedido._bigExactDispositivoLectura al aplicar CNXT.
  let boolFocoMaterialBigExact = false;
  const errores = [];
  if (pedido.listCABIN.clsZES_CAB_INPUT[0].VKORG_DESCR?.toUpperCase() === "RODENSTOCK") {
    if (ojoInDerecho.IDL_BIGEXACT) {
      if (ojoInDerecho.FOCO_MATERIAL === "MA" || ojoInIzquierdo.FOCO_MATERIAL === "MA")
        boolFocoMaterialBigExact = true; //Monofocal BIG EXACT
      if (ojoInDerecho.FOCO_MATERIAL === "PA" || ojoInIzquierdo.FOCO_MATERIAL === "PA")
        boolFocoMaterialBigExact = true; //Progresivo BIG EXACT
      if (ojoInDerecho.FOCO_MATERIAL === "PD" || ojoInIzquierdo.FOCO_MATERIAL === "PD")
        boolFocoMaterialBigExact = true; //Ocupac. BIG EXACT

      const dispositivoLectura = String(pedido._bigExactDispositivoLectura || "").trim();
      if (dispositivoLectura) {
        const okDneye = dispositivoLectura.toUpperCase().includes("DNEYE");
        if (!boolFocoMaterialBigExact || !okDneye) {
          errores.push(t("big_exact_seleccionar_lectura_dneye"));
        }
      }
    }
  }

  //JH.2024-07-01: VALIDAR: Si es cliente Wells la Referencia del Pedido debe contener almenos 8 caracteres seguidos y numéricos
  const { useIndoStore } = await import("@/stores/indo");
  const indoStore = useIndoStore();
  const jerarquiaSuperior = (indoStore.preferredOrgVenta?.JERARQUIA_SUPERIOR || "").toUpperCase();
  if (jerarquiaSuperior === "WELLS" || jerarquiaSuperior === "WELLS_PT") {
    if (!/\d{8}/.test(pedido.listCABIN.clsZES_CAB_INPUT[0].REF_CLIENT)) {
      errores.push(t("referencia_pedido_sonae"));
    }
  }

  //JH.2024-10-30: VALIDAR: Si tiene Forma (y no es Forma Básica) + Tipo de Montura <> Taladrada debe seleccionar una Orientación
  //ORIGEN_DATOS: ""=Ninguna | S=Basica | M=Marcas | C=Mis Biselados | B=Biselador Remoto | F=IndoScan
  //TIPO_MONTURA: I=Taladrada | N=Ranurada | A=Acetato | M=Metal
  const origenesConForma = ["M", "C", "B", "F"];
  if (origenesConForma.includes(pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS)) {
    if (
      pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_MONTURA &&
      pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_MONTURA !== "I"
    ) {
      if (!pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIENTACION) {
        errores.push(t("debe_seleccionar_orientacion_bisel"));
      }
    }
  }

  //JH.2024-10-30: VALIDAR: Si es pedido Rodenstock y ha seleccionado orientación de bisel "Centrado" FUNCIONA
  if (areaCliente.TEXTO_ORGANIZACION.toUpperCase() === "RODENSTOCK") {
    if (pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIENTACION === "03") {
      errores.push(t("lentes_rodenstock_no_admiten_orientacion_centrado"));
    }
  }

  //JH.2026-05-26: VALIDAR: Si se informa el Cilindro el valor debe ser major que cero.
  const cilindroIncorrecto = (x) => !isEmpty(x) && (isNaN(parseFloat(x)) || parseFloat(x) === 0);
  if (cilindroIncorrecto(ojoInDerecho.CILINDRO) || cilindroIncorrecto(ojoInIzquierdo.CILINDRO)) {
    errores.push(t("cilindro_vacio_o_distinto_de_cero"));
  }

  //JH.2025-01-28: VALIDAR: Si se informa el Eje debe informarse el Cilindro( NO SALE EL ERROR COMO NOTIFICACION PERO SI QUE SALE EN LA CONSOLA I NO TE DEJA ENVIAR PARA COMPROBAR)
  if (
    (!isEmpty(ojoInDerecho.EJE) && isEmpty(ojoInDerecho.CILINDRO)) ||
    (!isEmpty(ojoInIzquierdo.EJE) && isEmpty(ojoInIzquierdo.CILINDRO))
  ) {
    errores.push(t("eje_cilindro_obligatorios"));
  }

  //JH.2025-08-25: VALIDAR: Si se informa el Cilindro debe informarse el Eje en determinados casos(FUNCIONA)
  // Solo valida cuando cilindro > 0 (no cuando es 0 o vacío)
  const cilindroOD = parseFloat(ojoInDerecho.CILINDRO) || 0;
  const cilindroOI = parseFloat(ojoInIzquierdo.CILINDRO) || 0;
  const ejeODVacio = isEmpty(ojoInDerecho.EJE);
  const ejeOIVacio = isEmpty(ojoInIzquierdo.EJE);

  if ((cilindroOD > 0 && ejeODVacio) || (cilindroOI > 0 && ejeOIVacio)) {
    const diametro = ojoInDerecho.DIAMETRO || ojoInIzquierdo.DIAMETRO || "";
    const tieneDiametro = /[\/X#]/i.test(diametro);
    const tieneForma = ["S", "M", "C", "B", "F"].includes(
      pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS,
    );
    const tieneAdicion =
      (parseFloat(ojoInDerecho.ADICION) || 0) > 0 || (parseFloat(ojoInIzquierdo.ADICION) || 0) > 0;

    if (tieneDiametro) {
      errores.push(t("debe_introducir_datos_producto_diametro"));
    } else if (tieneForma) {
      errores.push(t("lentes_forma_informar_eje"));
    } else if (tieneAdicion) {
      errores.push(t("lentes_progresivas_informar_eje"));
    }
  }

  //JH.2025-06-13: VALIDAR: Si TieneMimetikaPro y no TieneMimetika, que no tenga asignado el TIPO_ISOTIPO "Isotipo" ya que no es compatible con MimetikaPro
  const esMimetikaPro = bEsMimetikaPro(ojoInDerecho.JER_EDI_INET);
  if (esMimetikaPro && (ojoInDerecho.TIPO_ISOTIPO === "A" || ojoInIzquierdo.TIPO_ISOTIPO === "A")) {
    errores.push(t("seleccione_tipo_isotipo"));
  }

  // Validaciones CLASE_PROG
  if (ojoInDerecho.CLASE_PROG === "I") {
    if (!isEmpty(ojoInDerecho.TIPO_PROG)) {
      errores.push(
        t("clase_prog_individual_sin_tipo_prog"),
      );
    }
    if (isEmpty(ojoInDerecho.ALT_PAS)) {
      errores.push(
        t("clase_prog_individual_requiere_altura_corredor"),
      );
    }
  }

  if (ojoInDerecho.CLASE_PROG === "X") {
    if (!isEmpty(ojoInDerecho.TIPO_PROG)) {
      errores.push(
        t("clase_prog_flex_sin_tipo_prog"),
      );
    }
    if (!isEmpty(ojoInDerecho.ALT_PAS)) {
      errores.push(
        t("clase_prog_flex_sin_altura_corredor"),
      );
    }
  }

  if (ojoInDerecho.CLASE_PROG === "F") {
    if (!isEmpty(ojoInDerecho.ALT_PAS)) {
      errores.push(
        t("clase_prog_fijo_sin_altura_corredor"),
      );
    }
    if (isEmpty(ojoInDerecho.TIPO_PROG)) {
      errores.push(
        t("clase_prog_fijo_requiere_tipo_prog"),
      );
    }
  }

  //JH.2026-04-14: VALIDAR: Si es EasyMax debe tener forma
  const bEsEasyMaxVal = caracteristicasLente.Personal === "AE";
  if (bEsEasyMaxVal && !pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS) {
    errores.push(t("para_lentes_easymax_debe_seleccionar_una_forma"));
  }

  //JH.2026-04-20: VALIDAR: Si tiene coloración con degradado los dos ojos debe ser del mismo diámetro
  const selectedLists = useSelectedListsStore();
  if (selectedLists.tono) {
    const selectedTono = selectedLists.tonos.find((o) => o.CARACTERISTICA === ojoInDerecho.TONO);
    const bTieneDegradado = selectedTono.Degradado === true;
    if (bTieneDegradado && ojoInDerecho.DIAMETRO != ojoInIzquierdo?.DIAMETRO) {
      errores.push(t("las_lentes_con_degradado_deben_tener_el_mismo_diametro"));
    }
  }

  //IMPORTANTE: MANTENER ESTA VALIDACIÓN SIEMPRE COMO LA ULTIMA, DENTRO DE LAS "Validaciones para todos los pedidos"
  //VALIDAR: Referencia de pedido debe estar informada si estamos enviando. Para calcular no es necesario.
  if (sending) {
    const refClient = pedido.listCABIN?.clsZES_CAB_INPUT?.[0]?.REF_CLIENT;
    if (!String(refClient ?? "").trim().length >= 1) {
      errores.push(t("referencia_pedido_obligatoria"));
    }
  }

  //----------------------------------------------------------------------------------------------------------------------------------------
  // END Validaciones para todos los pedidos (Normales o Enviados a Revisión)
  //----------------------------------------------------------------------------------------------------------------------------------------

  //----------------------------------------------------------------------------------------------------------------------------------------
  // START Validaciones para pedidos Normales (No enviados a Revisión)
  //----------------------------------------------------------------------------------------------------------------------------------------

  if (!review) {
    //Mira si al afegir una montura ha posat el codi

    if (
      !ojoInDerecho.JER_EDI_INET.trim() &&
      !ojoInIzquierdo.DIAMETRO.trim() &&
      !ojoInIzquierdo.JER_EDI_INET.trim() &&
      !ojoInIzquierdo.DIAMETRO.trim()
    ) {
      errores.push(t("debe_introducir_datos_producto_diametro"));
    }

    //Avisos de falta diámetro(funciona)
    if (
      ojoInDerecho.DIAMETRO === "" &&
      (ojoInDerecho.ESFERA || ojoInDerecho.CILINDRO || ojoInDerecho.ADICION)
    ) {
      errores.push(t("debe_escoger_un_diametro"));
    }

    if (
      ojoInIzquierdo.DIAMETRO === "" &&
      (ojoInIzquierdo.ESFERA || ojoInIzquierdo.CILINDRO || ojoInIzquierdo.ADICION)
    ) {
      errores.push(t("debe_escoger_un_diametro"));
    }

    //Si hi ha caracters cirílics no deixa enviar(funciona)
    if (miraSiHayCirilicos(pedido.listCABIN.clsZES_CAB_INPUT[0].REF_CLIENT)) {
      errores.push(t("caracter_no_valido"));
    }

    //Si és precalibrat i no hi ha forma que avisi
    // Leer PRECALIBRADO desde los ojos (mismo valor en ambos)
    const precalibradoOD =
      pedido.listOJOIN.clsZES_OJO_INPUT.find((o) => o.ZOJO === "D")?.PRECALIBRADO || "";
    if (
      (precalibradoOD === "F" || precalibradoOD === "B") &&
      !pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS
    ) {
      errores.push(
        t("debe_seleccionar_una_forma_antes_de_usar_precalibrado_o_espesor_borde_especial"),
      );
    }

    //Si és precalibrat i no hi ha tipus montura que avisi(trim problema)
    if (precalibradoOD === "F" && !pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_MONTURA) {
      errores.push(
        t("precalibrado_requiere_montura_y_bisel"),
      );
    }

    //Si és precalibrat i no hi ha tipus de bisell que avisi(trim problem)
    if (precalibradoOD === "F" && !pedido.listCABFRM.clsZES_CAB_FORMA[0].BISEL) {
      errores.push(
        t("precalibrado_requiere_montura_y_bisel"),
      );
    }

    //Si és montaje, diferent de segunda gafa i no hi ha tipus montura que avisi (trim problem)
    if (
      pedido.listCABIN.clsZES_CAB_INPUT[0].MONTAJE === "X" &&
      pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS !== "G" &&
      isEmpty(pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_MONTURA)
    ) {
      errores.push(t("completar_datos_montura"));
    }

    //Si és montaje, diferent de segunda gafa i no hi ha tipus de bisell que avisi (trim problem)
    if (
      pedido.listCABIN.clsZES_CAB_INPUT[0].MONTAJE === "X" &&
      pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS !== "G" &&
      !pedido.listCABFRM.clsZES_CAB_FORMA[0].BISEL
    ) {
      errores.push(t("completar_datos_montura"));
    }

    //Si és montaje, diferent de segunda gafa i no hi ha orientació de bisell que avisi (trim problem)
    if (
      pedido.listCABIN.clsZES_CAB_INPUT[0].MONTAJE === "X" &&
      pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS !== "G" &&
      !pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIENTACION
    ) {
      // Solo validar si el bisel NO es "03" (Plano)
      if (pedido.listCABFRM.clsZES_CAB_FORMA[0].BISEL !== "03") {
        errores.push(t("completar_datos_montura"));
      }
    }

    //PasoSegundaReceta
    /** TODO: Victor.2024-11-06: Por saber que es PasoSegundaReceta
        if (Model.PasoSegundaReceta !== "E" && Model.PasoSegundaReceta !== "1") {
            Model.PasoSegundaReceta = "1";
        } */

    //rellenar_datos_Tipo_altura
    /** TODO: Victor.2024-11-06: Por saber que es rellenar_datos_Tipo_altura
        if (rellenar_datos_Tipo_altura("Enviar el Pedido") === false) {
            return false;
        } */

    //Mirar si té forma i demanen bisellat o mod.espessors i no te altura ni dist.np
    errores.push(...miraSiFaltanDatosMontaje(pedido));

    // Posem a pinyo fix el diametre 80 per el maxima (no FreeMax: OPT_FRMX = diámetro elegido en UI).
    const ojoDiamRef = pedido.listOJOIN.clsZES_OJO_INPUT.find((o) => o.ZOJO === "D");
    if (miraSiMaximaAPartirJergaSinOjo(caracteristicasLente) && ojoDiamRef?.OPT_FRMX !== "X") {
      pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "D")[0].DIAMETRO = "80";
      pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "I")[0].DIAMETRO = "80";
    }

    //Per igualar el precalibrat des de indonet i des de SAP
    //Enviem sempre esp_borde="-1" quan precalibrado="F"

    if (ojoInDerecho.PRECALIBRADO === "F" || ojoInIzquierdo.PRECALIBRADO === "F") {
      ojoInDerecho.ESP_BORDE = "-1";
      ojoInIzquierdo.ESP_BORDE = "-1";
    }

    //busca les bases si es FFS i està activat el Base Automática
    /** Victor.2024-11-06: COmentado a peticion del cliente
        if (bBaseAutomatica) {
            try {
                let CodigoRetornoBases = eErrores.enumERROR;
                let sOjo = "D";
                CodigoRetornoBases = BuscaBaseAutomatica(sOjo);
                if (CodigoRetornoBases !== eErrores.enumOK) {
                    alert(Resources.Strings.consulta_bases_con_error);
                    return false;
                }
            } catch (ex) {
                return false;
            }
        }*/

    //Mira si hi han dades de prisma(funciona)
    if (ojoInDerecho.DIOP_PR1 !== "") {
      if (ojoInDerecho.GRAD_PR1 === "" && ojoInDerecho.BASE_PR1 === "") {
        errores.push(t("no_especificado_eje_base_prisma"));
      }
    }
    if (ojoInIzquierdo.DIOP_PR1 !== "") {
      if (ojoInIzquierdo.GRAD_PR1 === "" && ojoInIzquierdo.BASE_PR1 === "") {
        errores.push(t("no_especificado_eje_base_prisma"));
      }
    }
    if (ojoInDerecho.DIOP_PR2 !== "") {
      if (ojoInDerecho.GRAD_PR2 === "" && ojoInDerecho.BASE_PR2 === "") {
        errores.push(t("no_especificado_eje_base_prisma"));
      }
    }
    if (ojoInIzquierdo.DIOP_PR2 !== "") {
      if (ojoInIzquierdo.GRAD_PR2 === "" && ojoInIzquierdo.BASE_PR2 === "") {
        errores.push(t("no_especificado_eje_base_prisma"));
      }
    }

    //Si te demanat isotipo i no te montura avisa
    if (
      (ojoInDerecho.ISOTIPO === "X" || ojoInIzquierdo.ISOTIPO === "X") &&
      miraSiTieneFormas(pedido) === false
    ) {
      errores.push(
        t("isotipo_requiere_forma"),
      );
    }

    //Ha demanat Forma: Básicas

    //Ha demanat Forma Básica i no ha sel·leccionat cap de les Formas Básicas
    if (pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS === "S") {
      if (
        pedido.listCABFRM.clsZES_CAB_FORMA[0].FORMA_BASICA === 0 ||
        pedido.listCABFRM.clsZES_CAB_FORMA[0].FORMA_BASICA === "0"
      ) {
        errores.push(t("especificar_forma_basica"));
      }
    }

    //JH.2026-04-28: Hay un ORIGEN_DATOS seleccionado y faltan Datos de Montaje
    if (pedido.listCABFRM.clsZES_CAB_FORMA[0].ORIGEN_DATOS !== "") {
      if (
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].CALIBRE ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].PUENTE ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].ALT_BOX ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].DIST_NP_OD ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].DIST_NP_OI ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].ALTURA_OD ||
        !pedido.listCABFRM.clsZES_CAB_FORMA[0].ALTURA_OI
      ) {
        errores.push(t("completar_todos_datos_montaje"));
      }
    }

    //JH.2023-07-11: Si es Rodenstock, no permite Indices deferentes en cada ojo
    //NdV: 2024-11-06: Jordi, a OnStop no es diferencia entre ull dret i esquerra a la hora de demenar el indice
    if (ojoInDerecho.IND_REF !== "" && ojoInIzquierdo.IND_REF !== "") {
      if (areaCliente.TEXTO_ORGANIZACION.toUpperCase() === "RODENSTOCK") {
        if (ojoInDerecho.IND_REF !== ojoInIzquierdo.IND_REF) {
          errores.push(t("indice_mismo_ambos_ojos"));
        }
      }
    }

    //JH:2023-11-16: Sólo permitimos Puente en blanco o con un valor mayor que cero
    let boolPuenteValido = true;
    if (pedido.listCABFRM.clsZES_CAB_FORMA[0].PUENTE !== "") {
      if (
        !isNaN(parseFloat(pedido.listCABFRM.clsZES_CAB_FORMA[0].PUENTE)) &&
        parseFloat(pedido.listCABFRM.clsZES_CAB_FORMA[0].PUENTE) > 0
      ) {
        boolPuenteValido = true;
      } else {
        boolPuenteValido = false;
      }
    }
    if (!boolPuenteValido) {
      errores.push(t("puente_no_valido"));
    }

    //JH.2023-12-01: VALIDAR: Si se pide biselado y se envían menos de 600 puntos de radios con valor mayor que cero
    //if (pedido.CABFRM.BISEL) {
    //    for (const forma of pedido.listFORMAS) {
    //        if (forma.TIPOPUNTOS === "R") {
    //            const strPuntosSinPuntoInicial = forma.PUNTOS.substring(4); //Quitamos los primeros 4 números que son el punto inicial
    //            const strPuntosSinCeros = strPuntosSinPuntoInicial.trimEnd("0"); //Quitamos los puntos con valor cero del final
    //            const iPuntosCount = strPuntosSinCeros.length / 2; //Obtenemos el Len y lo dividimos por 2, ya que cada 2 caracteres hexadecimales son el punto diferencial del anterior
    //            const totalPuntos = iPuntosCount + 1; //Le sumamos uno por el punto inicial que hemos quitado al principio
    //            if (totalPuntos < 600) { //Si el total de puntos es menor que 600
    //                alert("No se aceptan biselados con menos de 600 puntos en la forma");
    //                return false;
    //            }
    //        }
    //    }
    //}
  }

  //----------------------------------------------------------------------------------------------------------------------------------------
  // END Validacions para pedidos Normales (No enviados a Revisión)
  //----------------------------------------------------------------------------------------------------------------------------------------

  //Si pasa todas las validaciones -> Return True
  // Filtrar errores duplicados antes de retornar
  return [...new Set(errores)];
};
//----------------------------------------------------------------------------------------------------------------------------------------
// END validarCondicionesIniciales
//----------------------------------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------------------------------
// Funciones auxiliares para validaciones
//----------------------------------------------------------------------------------------------------------------------------------------

const bEsMimetikaPro = (JER_EDI_INET) => {
  if (JER_EDI_INET) {
    return String(JER_EDI_INET).includes(" Pro");
  }
  return false;
};

const bEsEasyMax = (caracteristicasLente) => {
  if (caracteristicasLente.Personal === "AE") return true;
  return false;
};

const bTieneDegradado = (tono) => {
  const selectedLists = useSelectedListsStore();
  if (!Array.isArray(selectedLists.tonos)) return false;
  const selectedTono = selectedLists.tonos.find((o) => o.CARACTERISTICA === tono);
  if (!selectedTono) return false;
  return selectedTono.Degradado;
};

const miraSiFaltanDatosMontaje = (pedido) => {
  const errores = [];
  // Obtener los ojos del pedido
  const ojoInDerecho = pedido.listOJOIN.clsZES_OJO_INPUT.find((o) => o.ZOJO === "D");
  const ojoInIzquierdo = pedido.listOJOIN.clsZES_OJO_INPUT.find((o) => o.ZOJO === "I");

  // Leer PRECALIBRADO desde los ojos (mismo valor en ambos)
  const precalibradoVal = ojoInDerecho?.PRECALIBRADO || "";

  // Si es precalibrado "B", retornamos true directamente
  if (precalibradoVal === "B") {
    return errores;
  }

  // Comprobamos si tiene bisel, mod_espesores, precalibrado o es maxima
  if (
    !isEmpty(pedido.listCABIN.clsZES_CAB_INPUT[0].BISEL) ||
    !isEmpty(pedido.listCABIN.clsZES_CAB_INPUT[0].MOD_ESPESORES) ||
    !isEmpty(precalibradoVal) ||
    pedido.bEsMaxima
  ) {
    const cabForma = pedido.listCABFRM.clsZES_CAB_FORMA[0];

    // Comprobamos ojo derecho: si faltan datos, intentar rellenar desde listOJOIN
    if (
      recetaValida(ojoInDerecho) &&
      (isEmpty(cabForma.ALTURA_OD) || isEmpty(cabForma.DIST_NP_OD))
    ) {
      if (!isEmpty(ojoInDerecho?.DIST_NP) || !isEmpty(ojoInDerecho?.ALT_ARO)) {
        cabForma.DIST_NP_OD = cabForma.DIST_NP_OD || ojoInDerecho.DIST_NP || "";
        cabForma.ALTURA_OD = cabForma.ALTURA_OD || ojoInDerecho.ALT_ARO || "";
      } else {
        errores.push(
          t("montaje_falta_altura_dnp_od", { ojo: t("od") }),
        );
      }
    }

    // Comprobamos ojo izquierdo: si faltan datos, intentar rellenar desde listOJOIN
    if (
      recetaValida(ojoInIzquierdo) &&
      (isEmpty(cabForma.ALTURA_OI) || isEmpty(cabForma.DIST_NP_OI))
    ) {
      if (!isEmpty(ojoInIzquierdo?.DIST_NP) || !isEmpty(ojoInIzquierdo?.ALT_ARO)) {
        cabForma.DIST_NP_OI = cabForma.DIST_NP_OI || ojoInIzquierdo.DIST_NP || "";
        cabForma.ALTURA_OI = cabForma.ALTURA_OI || ojoInIzquierdo.ALT_ARO || "";
      } else {
        errores.push(
          t("montaje_falta_altura_dnp_oi", { ojo: t("oi") }),
        );
      }
    }
  }

  return errores;
};

const miraSiMaximaAPartirJergaSinOjo = (lentes) => {
  const sFoco = lentes?.FocoMaterial;
  const sPersonal = lentes?.Personal;

  return (sFoco === "PX" || sFoco === "MX") && sPersonal !== "AE";
};

const miraSiMaximaAPartirJerga = (ojo, lentes) => {
  // NO Actualitza el pedido. Només és per mirar si ho és
  // Canviat model per me2018-09-12

  let sFoco = "";
  let sPersonal = "";

  sFoco = lentes?.FocoMaterial;
  sPersonal = lentes?.Personal;

  if (
    (sFoco === "PX" ||
      ojo.FOCO_MATERIAL === "PX" ||
      sFoco === "MX" ||
      ojo.FOCO_MATERIAL === "MX") &&
    sPersonal !== "AE"
  ) {
    return true;
  }

  return false;
};

const miraSiTieneFormas = (pedido) => {
  // Si no tiene modelo ni calibre, retorna false
  if (
    isEmpty(pedido.listCABFRM.clsZES_CAB_FORMA[0].MODELO) &&
    isEmpty(pedido.listCABFRM.clsZES_CAB_FORMA[0].CALIBRE)
  ) {
    //And String.IsNullOrEmpty(pedido.FormaROD) Then
    return false;
  }

  // Si es modo INDONETFFS y tiene formas, actualiza PRECALIBRADO
  /** Victor.2024-11-06:  Eliminado por petición de cliente
    if (Model.Mode === "INDONETFFS") {
        pedido.PRECALIBRADO = "F";
    }*/

  return true;
};

const rellenar_datos_Tipo_altura = (profile, pedido) => {
  // Si viene de IndoCenter, retornamos true directamente
  if (pedido.bVieneDeIndoCenter) {
    return true;
  }

  // Si ambas alturas son 0, retornamos true
  if (
    Number(pedido.listCABFRM.clsZES_CAB_FORMA[0].ALTURA_OD) === 0 &&
    Number(pedido.listCABFRM.clsZES_CAB_FORMA[0].DIST_NP_OI) === 0
  ) {
    return true;
  }

  // Si el tipo de altura no coincide
  if (profile.DatosConfig.DETALLES.TIPO_ALT !== pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_ALTURA) {
    let sConfiguracion, sPedido;

    // Get Config Cliente
    if (profile.DatosConfig.DETALLES.TIPO_ALT === "B") {
      sConfiguracion = "Boxing";
    } else if (profile.DatosConfig.DETALLES.TIPO_ALT === "A") {
      sConfiguracion = "Aro";
    } else {
      sConfiguracion = "Desconocido";
    }

    // Get Config Pedido
    if (pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_ALTURA === "B") {
      sPedido = "Boxing";
    } else if (pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_ALTURA === "A") {
      sPedido = "Aro";
    } else {
      sPedido = "Desconocido";
    }

    const sCadena = `El tipo de Altura de Montaje del Pedido no coincide con el de la Configuración de la Óptica:

                  Óptica: ${sConfiguracion}
                  Pedido: ${sPedido}

                  ¿Desea actualizar la configuración del Pedido?

                  [Si] para cambiar la Altura de Montaje del pedido a ${sConfiguracion}.
                  [No] para mantener la Altura de Montaje del Pedido a ${sPedido}.`;

    // En JavaScript usaremos confirm en lugar de MsgBox
    const confirmResult = confirm(sCadena);

    if (confirmResult) {
      pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_ALTURA = profile.DatosConfig.DETALLES.TIPO_ALT;
      return false;
    }
  }

  return true;
};

const enviarARevisarPedido = (pedido, ojoInDerecho, ojoInIzquierdo, lentes) => {
  const skip80Freemax =
    pedido.listOJOIN?.clsZES_OJO_INPUT?.find((o) => o.ZOJO === "D")?.OPT_FRMX === "X";
  if (!skip80Freemax && miraSiMaximaAPartirJerga(ojoInDerecho, lentes)) {
    pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "D")[0].DIAMETRO = "80";
  }
  if (!skip80Freemax && miraSiMaximaAPartirJerga(ojoInIzquierdo, lentes)) {
    pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "I")[0].DIAMETRO = "80";
  }

  rellenar_datos_cliente(pedido);
  rellenar_datos_Secundarios(pedido);

  // Si te demanat isotipo i no te montura avisa
  if (
    (pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "D")[0].ISOTIPO === "X" ||
      pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "I")[0].ISOTIPO === "X") &&
    !miraSiTieneFormas(pedido)
  ) {
    return [
      t("isotipo_requiere_forma"),
    ];
  }

  // ValidarPedido --------------------------------------------------------
  // NdV: 2024-11-13: Comentado porque ya se esta haciendo en en envio del pedido
  // if (!ValidarCondicionesIniciales()) {
  //     return false;
  // }
  // / ValidarPedido ------------------------------------------------------

  // JH.2023-09-05: To TEST: Cambiar a MODO_FUNCIONAM = "A" para guardar en PA sin realizar ninguna validación.
  pedido.MODO_FUNCIONAM = "B";
  return true;
};

const enviarPedido = (pedido, tipoEnvio = "") => {
  // Per igualar el precalibrat des de indonet i des de SAP
  // Enviem sempre esp_borde="-1" quan precalibrado="F"

  // Leer PRECALIBRADO desde los ojos (mismo valor en ambos)
  const precalibradoEnvio =
    pedido.listOJOIN.clsZES_OJO_INPUT.find((o) => o.ZOJO === "D")?.PRECALIBRADO || "";
  if (precalibradoEnvio === "F") {
    pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "D")[0].ESP_BORDE = "-1";
    pedido.listOJOIN.clsZES_OJO_INPUT.filter((o) => o.ZOJO === "I")[0].ESP_BORDE = "-1";
  }

  rellenar_datos_cliente(pedido);
  rellenar_datos_Secundarios(pedido);

  if (isEmpty(tipoEnvio)) {
    pedido.MODO_FUNCIONAM = "V";
  } else {
    if (pedido.listCABOUT.clsZES_CAB_OUTPUT.length === 0) {
      pedido.listCABOUT.clsZES_CAB_OUTPUT = [{ IDENT_RAPIDO: "" }];
    }
    pedido.listCABOUT.clsZES_CAB_OUTPUT[0].IDENT_RAPIDO = "";
    pedido.MODO_FUNCIONAM = tipoEnvio;
  }
};

const rellenar_datos_cliente = (pedido, sClienteReceta = "") => {
  // pedido.CLIENTE = Model.Cliente.CLIENTE;
  pedido.listCABIN.clsZES_CAB_INPUT[0].AUGRU = "INET";
  pedido.listCABIN.clsZES_CAB_INPUT[0].FLAG_ONES = "X";
  const sTempKUNNR = pedido.listCABIN.clsZES_CAB_INPUT[0].KUNNR;

  // If Model.DatosConfig.CONFIGURACION IsNot Nothing Then
  //     pedido.CABIN.KUNNR = Model.DatosConfig.CONFIGURACION.KUNNR
  // End If

  if (isEmpty(pedido.listCABIN.clsZES_CAB_INPUT[0].KUNNR)) {
    pedido.listCABIN.clsZES_CAB_INPUT[0].KUNNR = pedido.CLIENTESAP;
  }

  if (pedido.bVieneDeReceta) {
    pedido.CLIENTE = sTempKUNNR;
    pedido.listCABIN.clsZES_CAB_INPUT[0].KUNNR = sTempKUNNR;
  }

  if (!isEmpty(sClienteReceta)) {
    pedido.CLIENTE = sClienteReceta;
    pedido.listCABIN.clsZES_CAB_INPUT[0].KUNNR = sClienteReceta;
  }
};

const rellenar_datos_Secundarios = (pedido) => {
  // Si hemos elegido una forma de un biselado remoto, tenemos que volver a setear los puntos por si
  // hay un redimensionado

  // NdV: 2024-11-13: Comentado la adquisiciond e montura. En este punto ya esta informada
  //                  en el caso de haber sido rellenada.
  // pedido.listCABFRM.clsZES_CAB_FORMA[0].CLAVEMONTURA = DAO.MonturasDAO.getClaveMontura(
  //     pedido.CABFRM.MARCA,
  //     pedido.CABFRM.MODELO,
  //     pedido.CABFRM.CALIBRE,
  //     pedido.CABFRM.ORIGEN_DATOS,
  //     pedido.CABFRM.PUENTEORIG
  // );

  // B = biselado remoto; F = IndoScan/ShapeScan — misma resincronización cabecera → filas forma
  const oDatos = pedido.listCABFRM?.clsZES_CAB_FORMA?.[0]?.ORIGEN_DATOS;
  if (oDatos === "B" || oDatos === "F") {
    // NdV: 2024-11-13: Comentado porque ya se esta haciendo en
    //                  la lectura del biselado
    // popularListaLecturas(_lecturasTrazador);

    if (!Array.isArray(pedido.listFORMAS?.clsZFORMAS) || pedido.listFORMAS.clsZFORMAS.length === 0)
      return;
    pedido.listFORMAS.clsZFORMAS.forEach((f) => {
      f.ORIGEN = oDatos;
      f.TIPO_ALTUR = pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_ALTURA ?? "";
      f.TIPO_MONTU = pedido.listCABFRM.clsZES_CAB_FORMA[0].TIPO_MONTURA ?? "";

      if (f.LENTE.trim().toUpperCase() === "D") {
        f.ALTURA = pedido.listCABFRM.clsZES_CAB_FORMA[0].ALTURA_OD;
        f.DIST_NP = pedido.listCABFRM.clsZES_CAB_FORMA[0].DIST_NP_OD;
      } else {
        f.ALTURA = pedido.listCABFRM.clsZES_CAB_FORMA[0].ALTURA_OI;
        f.DIST_NP = pedido.listCABFRM.clsZES_CAB_FORMA[0].DIST_NP_OI;
      }
    });
  }
};

const recetaValida = (ojo) => {
  return !isEmpty(ojo.ESFERA) || !isEmpty(ojo.CILINDRO) || !isEmpty(ojo.ADICION);
};

export {
  validarCondicionesIniciales,
  rellenar_datos_Tipo_altura,
  recetaValida,
  miraSiMaximaAPartirJerga,
  enviarARevisarPedido,
  enviarPedido,
};
